import React from "react";
import { ShieldCheck, Lock, Target, Zap, TrendingUp } from "lucide-react";
import { Reveal } from "../lib/motion";
import { TRUST } from "../data/site";

const ICONS = { ShieldCheck, Lock, Target, Zap, TrendingUp };

export const TrustBar = () => {
  return (
    <section className="relative border-y border-white/10 bg-surface/40" data-testid="trust-bar">
      <div className="container-pm py-8">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-6 gap-y-7">
          {TRUST.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <Reveal key={item.title} delay={i * 0.06} y={20} className="flex items-start gap-3">
                <div className="shrink-0 mt-0.5 text-coral">
                  <Icon size={20} strokeWidth={1.6} />
                </div>
                <span className="text-sm text-white/75 leading-snug">{item.title}</span>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
